module.exports = __webpack_public_path__ + "img/logo.fd77c02c.png";